import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    name: 'subtitle-5',
    price: 'subtitle-6 mt-1'
  }
} satisfies RecursivePartial<ProductConfig['upsell']>
